import React, { useEffect, useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";
import {
  StyledFilterBlock, StyledFilterBlockTitle,
  StyledFilterDropdownWrapper,
  StyledFilterGroup, StyledFilterWrapper, StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import DefaultButton from "../../../styles/materialButtonStyle";
import MappedServicesFilter from "../../../elements/serviceReletionships/mappedServices/MappedServicesFilter";

const BalancesFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("accountPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "currentTab": filterData["currentTab"],
    "service.name": null,
    "currency.asset": null,
    "totalAmount[gte]": "",
    "totalAmount[lte]": "",
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("balances.filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("balances.filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <MappedServicesFilter
              checkedService={filterData["service.name"]}
              setCheckedService={data => handleChangeFilterData(data, "service.name")}

              checkedCurrency={filterData["currency.asset"]}
              setCheckedCurrency={data => handleChangeFilterData(data, "currency.asset")}

              withPaymentSystem={false}
            />
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("balances.filter.balance")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="totalAmount[gte]">
                {t("balances.filter.balanceFrom")}
              </label>
              <DelayInput
                id="totalAmount[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "totalAmount[gte]": event.target.value, page: 1 })}
                name="totalAmount[gte]"
                value={filterData["totalAmount[gte]"]}
                type="number"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="totalAmount[lte]">
                {t("balances.filter.balanceTo")}
              </label>
              <DelayInput
                id="totalAmount[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "totalAmount[lte]": event.target.value, page: 1 })}
                name="totalAmount[lte]"
                value={filterData["totalAmount[lte]"]}
                type="number"
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("balances.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default BalancesFilter;